import React from "react";
import {
    X,
    AlertTriangle,
    Tag,
    CreditCard,
} from "lucide-react";

const XFinanceMappingModal = ({
    showMappingModal,
    setShowMappingModal,
    missingExpenseCategories,
    missingIncomeCategories,
    missingMethods,
    expenseCategories,
    incomeCategories,
    paymentMethods,
    paymentMethodsData,
    expenseCategoryMappings,
    setExpenseCategoryMappings,
    incomeCategoryMappings,
    setIncomeCategoryMappings,
    methodMappings,
    setMethodMappings,
    parsedData,
    handleMappingComplete,
    colors
}) => {
    if (!showMappingModal) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl max-w-2xl w-full max-h-[80vh] overflow-y-auto">
                <div className="p-6">
                    <div className="flex items-center justify-between mb-6">
                        <h2 className="text-xl font-bold text-slate-900 flex items-center gap-3">
                            <div className="w-8 h-8 bg-amber-100 rounded-lg flex items-center justify-center">
                                <AlertTriangle className="w-5 h-5 text-amber-600" />
                            </div>
                            Mapear Elementos Faltantes
                        </h2>
                        <button
                            onClick={() => setShowMappingModal(false)}
                            className="p-2 hover:bg-slate-100 rounded-lg transition-colors"
                        >
                            <X className="w-5 h-5 text-slate-400" />
                        </button>
                    </div>

                    <div className="space-y-6">
                        {/* Mapeo de Categorías de Gastos */}
                        {missingExpenseCategories.length > 0 && (
                            <div>
                                <h3 className="text-lg font-semibold text-slate-900 mb-4 flex items-center gap-2">
                                    <Tag className="w-5 h-5 text-red-600" />
                                    Categorías de Gastos no encontradas ({missingExpenseCategories.length})
                                </h3>
                                <div className="space-y-3">
                                    {missingExpenseCategories.map(missingCat => (
                                        <div key={missingCat} className="flex items-center gap-4 p-4 bg-red-50 rounded-lg">
                                            <div className="flex-1">
                                                <p className="font-medium text-slate-900">"{missingCat}"</p>
                                                <p className="text-sm text-slate-600">Mapear a categoría de gastos existente:</p>
                                            </div>
                                            <div className="flex-1">
                                                <select
                                                    value={expenseCategoryMappings[missingCat] || ""}
                                                    onChange={(e) => setExpenseCategoryMappings(prev => ({
                                                        ...prev,
                                                        [missingCat]: e.target.value
                                                    }))}
                                                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition-all"
                                                >
                                                    <option value="">Seleccionar categoría...</option>
                                                    {expenseCategories.map(cat => (
                                                        <option key={cat.id} value={cat.nombre}>
                                                            {cat.nombre}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Mapeo de Categorías de Ingresos */}
                        {missingIncomeCategories.length > 0 && (
                            <div>
                                <h3 className="text-lg font-semibold text-slate-900 mb-4 flex items-center gap-2">
                                    <Tag className="w-5 h-5 text-green-600" />
                                    Categorías de Ingresos no encontradas ({missingIncomeCategories.length})
                                </h3>
                                <div className="space-y-3">
                                    {missingIncomeCategories.map(missingCat => (
                                        <div key={missingCat} className="flex items-center gap-4 p-4 bg-green-50 rounded-lg">
                                            <div className="flex-1">
                                                <p className="font-medium text-slate-900">"{missingCat}"</p>
                                                <p className="text-sm text-slate-600">Mapear a categoría de ingresos existente:</p>
                                            </div>
                                            <div className="flex-1">
                                                <select
                                                    value={incomeCategoryMappings[missingCat] || ""}
                                                    onChange={(e) => setIncomeCategoryMappings(prev => ({
                                                        ...prev,
                                                        [missingCat]: e.target.value
                                                    }))}
                                                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all"
                                                >
                                                    <option value="">Seleccionar categoría...</option>
                                                    {incomeCategories.map(cat => (
                                                        <option key={cat.id} value={cat.nombre}>
                                                            {cat.nombre}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Mapeo de Métodos de Pago/Cobro */}
                        {missingMethods.length > 0 && (
                            <div>
                                <h3 className="text-lg font-semibold text-slate-900 mb-4 flex items-center gap-2">
                                    <CreditCard className="w-5 h-5 text-purple-600" />
                                    Métodos de pago/cobro no encontrados ({missingMethods.length})
                                </h3>
                                <div className="space-y-3">
                                    {missingMethods.map(missingMethod => (
                                        <div key={missingMethod} className="flex items-center gap-4 p-4 bg-slate-50 rounded-lg">
                                            <div className="flex-1">
                                                <p className="font-medium text-slate-900">"{missingMethod}"</p>
                                                <p className="text-sm text-slate-600">Mapear a método existente:</p>
                                            </div>
                                            <div className="flex-1">
                                                <select
                                                    value={methodMappings[missingMethod] || ""}
                                                    onChange={(e) => setMethodMappings(prev => ({
                                                        ...prev,
                                                        [missingMethod]: e.target.value
                                                    }))}
                                                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all"
                                                >
                                                    <option value="">Seleccionar método...</option>
                                                    {/* Determinar si es método de pago o cobro basado en el contexto */}
                                                    {parsedData.some(row => {
                                                        const rowType = row.tipo?.toLowerCase();
                                                        return (rowType === 'gasto' || rowType === 'expense') && row.metodoPago === missingMethod;
                                                    }) ? (
                                                        // Es un método de pago para gastos
                                                        paymentMethods.filter(method => method.activo).map(method => (
                                                            <option key={method.id} value={method.nombre}>
                                                                {method.nombre}
                                                            </option>
                                                        ))
                                                    ) : (
                                                        // Es un método de cobro para ingresos
                                                        paymentMethodsData.map(method => (
                                                            <option key={method} value={method}>
                                                                {method}
                                                            </option>
                                                        ))
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Información de mapeo */}
                        <div className={`${colors.bg} ${colors.border} border rounded-lg p-4`}>
                            <h4 className={`font-semibold ${colors.text} mb-2`}>¿Qué sucede al mapear?</h4>
                            <ul className={`${colors.textTertiary} text-sm space-y-1`}>
                                <li>• Todas las filas del CSV que usen el elemento original se cambiarán al elemento mapeado</li>
                                <li>• El mapeo se aplica a todo el archivo automáticamente</li>
                                <li>• Los elementos originales no se crean, solo se sustituyen</li>
                                <li>• Para ingresos por horas, el monto se recalcula automáticamente</li>
                            </ul>
                        </div>

                        {/* Botones del modal */}
                        <div className="flex gap-3 pt-4 border-t border-slate-200">
                            <button
                                onClick={() => setShowMappingModal(false)}
                                className="flex-1 px-4 py-2 border border-slate-300 text-slate-700 rounded-lg font-medium hover:bg-slate-50 transition-colors"
                            >
                                Cancelar
                            </button>
                            <button
                                onClick={handleMappingComplete}
                                className={`flex-1 px-4 py-2 ${colors.button} text-white rounded-lg font-medium transition-colors`}
                            >
                                Aplicar Mapeos
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default XFinanceMappingModal;